export default "__VITE_ASSET__BRwnY9iX__"